import { contentSheetResource } from "../content_textures"
import { Sex } from "game-common/character/character"
import { heldObjectSocket } from "game-common/lpc/hand_sockets"
import { Sprite } from "pixi.js"
import { trimTextureToContent } from "./texture_content_bounds"

export interface LpcHeldObject {
    spriteId: string
    sex: Sex
}

export const HELD_OBJECT_Y_OFFSET = 8

// The socket tables moved to game-common so authoring tools share them; re-exported for callers here.
export { heldObjectSocket, heldObjectBehindBody } from "game-common/lpc/hand_sockets"

/** Return an ordinary item-atlas sprite positioned in the compositor's centered frame space. */
export const createHeldObjectSprite = (held: LpcHeldObject, action: string, frame: number): Sprite | undefined => {
    const socket = heldObjectSocket(action, frame, held.sex)
    if (!socket) {
        return undefined
    }
    const [sheet, tile] = held.spriteId.includes(":") ? held.spriteId.split(":") : ["humanoid", held.spriteId]
    const key = held.spriteId.includes(":") ? `${sheet}-${tile}` : tile
    const texture = contentSheetResource(sheet)?.textures?.[key]
    if (!texture?.valid) {
        return undefined
    }
    const trimmed = trimTextureToContent(texture)
    const sprite = new Sprite(trimmed)
    // Lower the bottom-center anchor so the icon sits in the hands rather than
    // covering the wrist/shoulder at the measured socket.
    sprite.anchor.set(0.5, 1)
    sprite.scale.set(18 / Math.max(trimmed.orig.width, trimmed.orig.height))
    sprite.position.set(socket.x - 32, socket.y + HELD_OBJECT_Y_OFFSET - 32)
    return sprite
}
